import { Injectable } from '@angular/core';
import { NzModalService, NzMessageService } from 'ng-zorro-antd';
import { HttpService } from '../http/http-service.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { cloneDeep } from 'lodash';
import { merge } from 'lodash';
import { te } from 'date-fns/locale';
@Injectable({
  providedIn: 'root'
})
export class BaseService {
  listOfData: any;

  constructor(
    private message: NzMessageService,
    private httpService: HttpService
  ) { }
  /**
   * 渲染可编辑单元格数据格式，并给表格tableData赋值(工具)
   */
  initEditTableData(mapperList, obj) {
    let listOfData = [];
    const columns = obj.columns;
    for (let i = 0; i < mapperList.length; i++) {
      listOfData = [...listOfData, this.initRowData(columns, mapperList[i])];
    }
    return listOfData;
  }

  /**
   * 格式化每行数据格式(工具)
   */
  initRowData(columns, data) {
    const arr = {};
    columns.forEach((item) => {
      const tempAttrs = JSON.parse(JSON.stringify(item.attrs));
      const temp = {
        name: item.name,
        type: 'string',
        value: data[item.name] || data.showFormatter[item.name],
        edit: true,
        error: false,
        others: null,
        // isTemplete: true
      };
      const mutipleAttr = data.showFormatter[item.name];
      temp.type = tempAttrs.type;
      if (!item.others) {
        if (!tempAttrs.type || tempAttrs.type === 'string') {
          temp.type = 'string';
        }
        if (tempAttrs.type === 'float') {
          temp.type = 'float';
          temp.value = temp.value || 0.0;
        }
      }
      if (item.others) {
        const tempOthers = JSON.parse(JSON.stringify(item.others));
        if (tempOthers.type === 'date') {
        } else if (tempOthers.type === 'select') {
          tempOthers.defaultLoad = true;
          Object.defineProperty(tempOthers, 'width', { value: '100%', enumerable: true });
          if (data.showFormatter.colUiType) {
            const a = data.showFormatter.colUiType;
            let selectArr = [];
            if (a.length) {
              selectArr = a.split(',');
            }
            if (selectArr.length === 2) {
              tempOthers.selectedValue = { lable: selectArr[0], value: selectArr[1] };
            } else if (selectArr.length > 2) {
              let multipValue = '';
              let tag = ',';
              for (let i = 1; i < selectArr.length; i++) {
                if (i === selectArr.length - 1) {
                  tag = '';
                }
                multipValue += selectArr[i] + tag;
              }
              tempOthers.selectedValue = { lable: selectArr[0], value: multipValue };
            }
          }
        } else if (tempOthers.type === 'checkBox') {
          temp.type = 'boolean';
          temp.value = temp.value === 'true' ? true : false;
        }
        temp.others = tempOthers;
      }
      arr[temp.name] = temp;
    });
    return arr;
  }

  isRepeat(arr) {
    const hash = {};
    // tslint:disable-next-line:forin
    for (const i in arr) {
      if (hash[arr[i]]) {
        return true;
      }
      hash[arr[i]] = true;
    }
    return false;
  }


  // 提交工具编辑单元格数据
  subEditTableData(dataArr) {
    const mapperResult = [];
    if (dataArr && dataArr.length) {
      dataArr.forEach((d) => {
        const temp = { propertyName: d.propertyName.value, showFormatter: {} };
        for (const key in d) {
          if (d.hasOwnProperty(key)) {
            if (d[key].others && d[key].others.type === 'select') {
              if (d[key].others.selectedValue) {
                d[key].value = d[key].others.selectedValue.label + ',' + d[key].others.selectedValue.value;
              }
            }
            temp.showFormatter[key] = d[key].value;
            // temp.showFormatter['isTemplete'] = true;
          }
        }
        mapperResult.push(temp);
      });
    }
    return mapperResult;
  }

  setColumsFiex(columns) {
    columns.forEach((c) => {
      c.attrs.isLeft ? c.attrs.isLeft = JSON.parse(c.attrs.isLeft) : c.attrs.isLeft = false;
      c.attrs.isRight ? c.attrs.isRight = JSON.parse(c.attrs.isRight) : c.attrs.isRight = false;
    });
    return columns;
  }


  async getDynamicMapper(url, params) {
    const res = await this.httpService.httpGet(url, params).toPromise();
    if (res.code === 1) {
      if (res.data.mapperList && res.data.mapperList.length) {
        if (res.data.mapperList) {
          return res.data.mapperList;
          // mapperList = res.data.mapperList;
        }
      }
    }
  }

  initStaticFormData(staticFormConfig) {
    const colSpan = staticFormConfig.colSpan;
    const staticFormData = staticFormConfig.formConfig;
    if (!staticFormData) { return; }
    for (const key in staticFormData.items) {
      if (staticFormData.items.hasOwnProperty(key)) {
        const temp = staticFormData.items[key];
        temp.name = key;
        temp.isEdit = true;
        temp.description = temp.description || '';
        temp.errMessage = temp.errMessage || temp.title;
        if (!temp.ui) {
          const ui = { type: temp.type, colSpan: temp.colSpan ? temp.colSpan : staticFormData.colSpan };
          Object.defineProperty(temp, 'ui', { value: ui, enumerable: true });
        } else {
          temp.ui.colSpan = temp.ui.colSpan ? temp.ui.colSpan : staticFormData.colSpan;
        }
      }
    }
    return staticFormConfig;
  }

  initFormData(config, formData?): Observable<any> {
    return this.httpService.httpGet(config.url, config.params).pipe(
      map(res => {
        if (res.code === 1) {
          if (res.data === null) { return; }
          if (res.data.mapperList && res.data.mapperList.length) {
            if (res.data.mapperList) {
              return this.resetFormData(res.data.mapperList, formData);
            }
          }
        }
        return {};
      }),
    );
  }
  resetFormData(mapperList, formData?) {
    const items = {};
    let uiSpan = 8;
    if (formData && formData.colSpan) {
      uiSpan = formData.colSpan;
    }
    mapperList.forEach(item => {
      uiSpan = 8;
      const dateConfigArr = (item.showFormatter.colUiType || '文本框,text').split(',');
      const dataType = dateConfigArr[1];
      let dtype = 'text';
      let uiType = 'text';
      uiType = dataType;
      if (dataType === 'number') {
        dtype = uiType = dataType;
      }
      if (dataType === 'textArea') {
        uiSpan = 24;
      }
      const tempObj = {
        type: dtype,
        name: item.propertyName,
        title: item.showFormatter.showName,
        isRequire: JSON.parse(item.showFormatter.isRequire),
        errMessage: item.showFormatter.errMessage,
        ui: {
          type: uiType, colSpan: uiSpan, loading: false,
          unEdit: item.showFormatter.unEdit ? JSON.parse(item.showFormatter.unEdit) : false
        },
        description: item.showFormatter.description,
        value: item.showFormatter.defaultValue || null,
      };
      if (dataType === 'date' && dateConfigArr.length > 2) {
        for (let i = 2; i < dateConfigArr.length; i++) {
          tempObj[i] = true;
        }
      }

      if ((dataType === 'text' || dataType === 'textArea') && parseInt(item.showFormatter.maxLength, 0) > 0) {
        tempObj['maxLength'] = parseInt(item.showFormatter.maxLength, 0);
      }
      if (dataType === 'number' && parseFloat(item.showFormatter.maxLength) > 0) {
        const arr = item.showFormatter.maxLength.split('.');
        Object.defineProperty(tempObj, 'n', { value: arr, enumerable: true, writable: true });
      }
      items[item.propertyName] = tempObj;
      if (formData) {
        for (const key in formData.items) {
          if (formData.items.hasOwnProperty(key)) {
            if (key === item.propertyName) {
              const temp = cloneDeep(formData.items[key]);
              if (temp.ui) {
                temp.ui.type = uiType;
                temp.ui.colSpan = uiSpan;
                temp.ui.loading = false;
              } else {
                temp.type = 'text';
                const ui = {
                  colSpan: uiSpan, type: 'text', loading: false,
                  unEdit: item.showFormatter.unEdit ? JSON.parse(item.showFormatter.unEdit) : false
                };
                Object.defineProperty(temp, 'ui', { value: ui, enumerable: true });
              }
              temp.maxLength = item.showFormatter.maxLength;
              temp.isRequire = JSON.parse(item.showFormatter.isRequire);
              temp.value = item.showFormatter.defaultValue || null;
              temp.title = item.showFormatter.showName || temp.title;
              temp.errMessage = item.showFormatter.errMessage || temp.errMessage;
              temp.description = item.showFormatter.description || temp.description;
              if (dataType === 'radioBox') {
                temp.ui.type = 'radio';
              }
              if (dataType === 'checkBox') {
                temp.ui.type = 'checkBox';
              }
              if (dataType === 'date') {
                temp.ui.type = dataType;
              }
              if (dataType === 'code') {
                temp.ui.type = dataType;
              }
              if (dataType === 'select') {
                temp.ui.selectedValue = null;
                temp.value = null || temp.selectedValue;
                if (!temp.ui.data) {
                  temp.ui.data = [];
                }
              }
              items[item.propertyName] = temp;
            }
          }
        }
      }
    });
    return items;
  }

  setFormEdit(formData, flag) {
    const values = Object.values(formData.items);
    values.forEach((f) => {
      f['isEdit'] = flag;
    });
    formData.isEdit = flag;
    formData.show = true;
    return formData;
  }

  deepClone(obj) {
    // return _.isArray(obj) ? obj.slice() : _.extend(, obj);
  }

}
